import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { configService } from '../services/api';
import Navbar from './Navbar';

const CAMAS = ['Diamante','Roma','Barras','Portugal','Dos Lineas','Set base + respaldo','Romo Capitoneada','Roma Rombos','Adriana','Trineo','Canada','Doble Tapiz','Super Eco #1','Super Eco #2'];
const SOFAS = ['Sofa Paris Triple','Sala Paris 2 2','Sala Paris 3 2','Sofa Lisboa Triple','Sala Lisboa 2 2','Sala Lisboa 3 2','Sala Valencia 2 2','Sala Valencia 3 2','Sala Sofia 2 2','Sala Sofia 3 2','Sala Venecia 2 2','Sala Venecia 3 2','Sala Real 2 2','Sala Real 3 2','Sala Verona','Sofa Bruselas','Sofa Oslo','Sofa Praga','Sofa Malaga','Sofa Dallas','Divan Praga','Sofa Cama Palermo','Sofa Cama L modelo viejo','Sofa Cama Madrid','Sofa Cama Roma','Sofa Cama Italia','Reclinable modelo nuevo','Reclinable modelo Viejo','Reclinable Panama','Butacas'];
const TALLAS = ['Individual','Matrimonial','Queen','King'];
const ESTADOS = ['Pendiente','En Proceso','Completada'];
const estadoColor = { 'Pendiente':'#f59e0b','En Proceso':'#3b82f6','Completada':'#10b981' };
const empty = { categoria:'Cama', modelo:'', variante:'', cantidad:1, fabricante:'', fecha_entrega:'', observaciones:'' };

function PrintView({ order, logoUrl, onClose }) {
  const handlePrint = () => {
    const el = document.querySelector('.prod-print-area');
    if (!el) return;
    const html = `<html><head><meta charset="utf-8"><style>
      body{font-family:Arial,sans-serif;font-size:12px;padding:15mm;margin:0;}
      .row{display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px solid #f0e8e0;font-size:13px;}
      .label{color:#666;font-weight:600;}
      .value{font-weight:600;text-align:right;}
      .header{border-bottom:3px solid #5c3d2e;padding-bottom:16px;margin-bottom:20px;display:flex;justify-content:space-between;align-items:flex-start;}
      .title{font-size:18px;font-weight:800;color:#5c3d2e;}
      .numero{font-size:13px;font-weight:700;color:#a0522d;}
      img{max-height:52px;object-fit:contain;}
      @page{margin:0;size:A4;}
    </style></head><body>${el.innerHTML}</body></html>`;
    const win = window.open('', '_blank');
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => { win.print(); win.close(); }, 600);
  };

  const s = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300 },
    box: { background:'#fff', borderRadius:12, padding:32, maxWidth:600, width:'90%', maxHeight:'90vh', overflowY:'auto' },
    row: { display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #f0e8e0', fontSize:13 },
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div className="prod-print-area" style={s.box} onClick={e=>e.stopPropagation()}>
        <div style={{ borderBottom:'3px solid #5c3d2e', paddingBottom:16, marginBottom:20 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
            <div>
              {logoUrl ? <img src={logoUrl} alt="Logo" style={{ height:52, objectFit:'contain', marginBottom:4 }}/> : <div style={{ fontSize:20, fontWeight:900, color:'#5c3d2e' }}>🪑 Muebles Terrasol</div>}
              <div style={{ color:'#888', fontSize:13 }}>Muebles Terrasol</div>
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ fontSize:18, fontWeight:800, color:'#5c3d2e' }}>ORDEN DE PRODUCCIÓN</div>
              <div style={{ fontSize:13, fontWeight:700, color:'#a0522d' }}>{order.order_number}</div>
            </div>
          </div>
        </div>

        {[
          ['N° Orden', order.order_number],
          ['Fecha Solicitud', order.fecha_solicitud?.split('T')[0]],
          ['Fecha Estimada de Entrega', order.fecha_entrega?.split('T')[0] || '—'],
          ['Categoría', order.categoria],
          ['Modelo', order.modelo],
          ['Tamaño', order.variante || '—'],
          ['Cantidad', order.cantidad + ' unidad' + (order.cantidad > 1 ? 'es' : '')],
          ['Fabricante', order.fabricante || '—'],
          ['Estado', order.estado],
          ['Observaciones', order.observaciones || '—'],
        ].map(([l,v]) => (
          <div key={l} style={s.row}>
            <span style={{ color:'#666', fontWeight:600 }}>{l}</span>
            <span style={{ fontWeight:600, maxWidth:'60%', textAlign:'right' }}>{v}</span>
          </div>
        ))}

        <div style={{ display:'flex', gap:10, marginTop:24, justifyContent:'flex-end' }}>
          <button style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'10px 22px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:600 }} onClick={handlePrint}>🖨️ Imprimir</button>
          <button style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'10px 22px', borderRadius:8, cursor:'pointer', fontSize:14 }} onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}

function FormModal({ initial, onSave, onClose }) {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);
  const modelos = form.categoria === 'Cama' ? CAMAS : SOFAS;

  const handleSubmit = async () => {
    if (!form.modelo || !form.cantidad) return alert('Completa los campos requeridos');
    setLoading(true);
    await onSave(form);
    setLoading(false);
  };

  const s = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200 },
    modal: { background:'#fff', borderRadius:16, padding:32, width:'100%', maxWidth:500, maxHeight:'90vh', overflowY:'auto' },
    input: { width:'100%', padding:'10px 12px', borderRadius:8, border:'1px solid #ddd', fontSize:14, boxSizing:'border-box' },
    select: { width:'100%', padding:'10px 12px', borderRadius:8, border:'1px solid #ddd', fontSize:14, background:'#fff', boxSizing:'border-box' },
    formGroup: { marginBottom:16 },
    formLabel: { display:'block', fontSize:13, fontWeight:600, color:'#5c3d2e', marginBottom:6 },
    btnPrimary: { background:'#5c3d2e', color:'#fff', border:'none', padding:'10px 20px', borderRadius:8, cursor:'pointer', fontWeight:600, fontSize:14 },
    btnSecondary: { background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'10px 20px', borderRadius:8, cursor:'pointer', fontSize:14 },
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e=>e.stopPropagation()}>
        <div style={{ fontSize:18, fontWeight:700, color:'#5c3d2e', marginBottom:20 }}>{initial.id ? 'Editar Orden' : 'Nueva Orden de Producción'}</div>

        <div style={s.formGroup}>
          <label style={s.formLabel}>Categoría</label>
          <select style={s.select} value={form.categoria} onChange={e=>setForm({...form, categoria:e.target.value, modelo:'', variante:''})}>
            <option>Cama</option>
            <option>Sofá</option>
          </select>
        </div>

        <div style={s.formGroup}>
          <label style={s.formLabel}>Modelo *</label>
          <select style={s.select} value={form.modelo} onChange={e=>setForm({...form, modelo:e.target.value})}>
            <option value=''>-- Seleccionar --</option>
            {modelos.map(m=><option key={m} value={m}>{m}</option>)}
          </select>
        </div>

        {form.categoria === 'Cama' && (
          <div style={s.formGroup}>
            <label style={s.formLabel}>Tamaño</label>
            <select style={s.select} value={form.variante} onChange={e=>setForm({...form, variante:e.target.value})}>
              <option value=''>-- Seleccionar --</option>
              {TALLAS.map(t=><option key={t} value={t}>{t}</option>)}
            </select>
          </div>
        )}

        <div style={s.formGroup}>
          <label style={s.formLabel}>Cantidad *</label>
          <input style={s.input} type='number' min='1' value={form.cantidad} onChange={e=>setForm({...form, cantidad:parseInt(e.target.value)||1})} />
        </div>

        <div style={s.formGroup}>
          <label style={s.formLabel}>Fabricante</label>
          <input style={s.input} type='text' placeholder='Nombre del fabricante' value={form.fabricante} onChange={e=>setForm({...form, fabricante:e.target.value})} />
        </div>

        <div style={s.formGroup}>
          <label style={s.formLabel}>Fecha estimada de entrega</label>
          <input style={s.input} type='date' value={form.fecha_entrega ? form.fecha_entrega.split('T')[0] : ''} onChange={e=>setForm({...form, fecha_entrega:e.target.value})} />
        </div>

        <div style={s.formGroup}>
          <label style={s.formLabel}>Observaciones</label>
          <textarea style={{...s.input, minHeight:70, resize:'vertical'}} placeholder='Notas adicionales...' value={form.observaciones||''} onChange={e=>setForm({...form, observaciones:e.target.value})} />
        </div>

        <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
          <button style={s.btnSecondary} onClick={onClose}>Cancelar</button>
          <button style={s.btnPrimary} onClick={handleSubmit} disabled={loading}>{loading ? 'Guardando...' : 'Guardar'}</button>
        </div>
      </div>
    </div>
  );
}

export default function Production() {
  const [orders, setOrders] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editOrder, setEditOrder] = useState(null);
  const [printOrder, setPrintOrder] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState('Todos');
  const [logoUrl, setLogoUrl] = useState(null);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchOrders = useCallback(async () => {
    try {
      const res = await axios.get('/api/production', { headers });
      setOrders(res.data);
    } catch (err) { console.error(err); }
  }, []);

  useEffect(() => {
    fetchOrders();
    setLogoUrl(configService.getLogoUrl());
  }, [fetchOrders]);

  const handleCreate = async (form) => {
    try {
      await axios.post('/api/production', form, { headers });
      setShowForm(false);
      fetchOrders();
    } catch (err) { alert('Error al crear orden'); }
  };

  const handleEdit = async (form) => {
    try {
      await axios.put(`/api/production/${editOrder.id}`, form, { headers });
      setEditOrder(null);
      fetchOrders();
    } catch (err) { alert('Error al editar orden'); }
  };

  const handleEstado = async (id, estado) => {
    try {
      await axios.patch(`/api/production/${id}/estado`, { estado }, { headers });
      fetchOrders();
    } catch (err) { alert('Error al actualizar estado'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar esta orden?')) return;
    try {
      await axios.delete(`/api/production/${id}`, { headers });
      fetchOrders();
    } catch (err) { alert('Error al eliminar'); }
  };

  const filtered = filtroEstado === 'Todos' ? orders : orders.filter(o=>o.estado===filtroEstado);

  const s = {
    page: { padding:'24px', maxWidth:1100, margin:'0 auto' },
    header: { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 },
    title: { fontSize:24, fontWeight:700, color:'#5c3d2e' },
    btnPrimary: { background:'#5c3d2e', color:'#fff', border:'none', padding:'10px 20px', borderRadius:8, cursor:'pointer', fontWeight:600, fontSize:14 },
    card: { background:'#fff', borderRadius:12, padding:'16px 20px', marginBottom:10, boxShadow:'0 1px 4px rgba(0,0,0,0.08)', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:12, cursor:'pointer' },
    label: { fontSize:11, color:'#888', marginBottom:2 },
    value: { fontSize:14, fontWeight:600, color:'#333' },
    badge: (estado) => ({ background: estadoColor[estado]||'#ccc', color:'#fff', padding:'4px 10px', borderRadius:20, fontSize:12, fontWeight:600 }),
    filters: { display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' },
    filterBtn: (active) => ({ background: active?'#5c3d2e':'#f0ebe5', color: active?'#fff':'#5c3d2e', border:'none', padding:'6px 16px', borderRadius:20, cursor:'pointer', fontSize:13, fontWeight: active?600:400 }),
  };

  return (
    <>
    <Navbar />
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.title}>🔧 Órdenes de Producción</div>
        <button style={s.btnPrimary} onClick={()=>setShowForm(true)}>+ Nueva Orden</button>
      </div>

      {/* Resumen */}
      <div style={{ display:'flex', gap:12, marginBottom:24, flexWrap:'wrap' }}>
        {ESTADOS.map(e=>(
          <div key={e} style={{ background:'#fff', borderRadius:10, padding:'12px 20px', boxShadow:'0 1px 4px rgba(0,0,0,0.08)', textAlign:'center', minWidth:120 }}>
            <div style={{ fontSize:22, fontWeight:700, color:estadoColor[e] }}>{orders.filter(o=>o.estado===e).length}</div>
            <div style={{ fontSize:12, color:'#888' }}>{e}</div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div style={s.filters}>
        {['Todos',...ESTADOS].map(f=>(
          <button key={f} style={s.filterBtn(filtroEstado===f)} onClick={()=>setFiltroEstado(f)}>{f}</button>
        ))}
      </div>

      {/* Lista */}
      {filtered.length===0 && <div style={{ textAlign:'center', color:'#aaa', padding:40 }}>No hay órdenes de producción</div>}
      {filtered.map(o=>(
        <div key={o.id} style={s.card} onClick={()=>setPrintOrder(o)}>
          <div>
            <div style={{ fontSize:13, fontWeight:700, color:'#5c3d2e', marginBottom:4 }}>{o.order_number}</div>
            <div style={s.value}>{o.modelo} {o.variante ? `— ${o.variante}` : ''}</div>
            <div style={{ fontSize:12, color:'#888' }}>{o.categoria} · {o.cantidad} unidad{o.cantidad>1?'es':''}</div>
          </div>
          <div>
            <div style={s.label}>Fabricante</div>
            <div style={s.value}>{o.fabricante||'—'}</div>
          </div>
          <div>
            <div style={s.label}>F. Entrega</div>
            <div style={s.value}>{o.fecha_entrega ? o.fecha_entrega.split('T')[0] : '—'}</div>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:8 }} onClick={e=>e.stopPropagation()}>
            <span style={s.badge(o.estado)}>{o.estado}</span>
            <select value={o.estado} onChange={e=>handleEstado(o.id,e.target.value)} style={{ padding:'4px 8px', borderRadius:6, border:'1px solid #ddd', fontSize:13 }}>
              {ESTADOS.map(e=><option key={e} value={e}>{e}</option>)}
            </select>
            <button onClick={()=>setEditOrder(o)} style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'6px 10px', borderRadius:6, cursor:'pointer', fontSize:13 }}>✏️</button>
            <button onClick={()=>handleDelete(o.id)} style={{ background:'#fee2e2', color:'#dc2626', border:'none', padding:'6px 10px', borderRadius:6, cursor:'pointer', fontSize:13 }}>🗑</button>
          </div>
        </div>
      ))}

      {showForm && <FormModal initial={empty} onSave={handleCreate} onClose={()=>setShowForm(false)} />}
      {editOrder && <FormModal initial={editOrder} onSave={handleEdit} onClose={()=>setEditOrder(null)} />}
      {printOrder && <PrintView order={printOrder} logoUrl={logoUrl} onClose={()=>setPrintOrder(null)} />}
    </div>
    </>
  );
}
